module.exports = __webpack_public_path__ + "static/media/BackButton.a8741ad3.svg";